module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-world-24dfd5b3a5763d90a454fe4550908db7.svg";